<template>
  <v-card class="payment-announcement-card">
    <div class="payment-announcement-card__hero">
      <img
        class="payment-announcement-card__logo"
        src="media/logos/robosay-logo-yatay.svg"
        alt="Robosay"
      />
      <div class="payment-announcement-card__eyebrow">Bilgilendirme</div>
      <h2>Kartlı ödeme işlemleri hakkında</h2>
      <p>
        Robosay'da kartlı ödeme deneyimini daha sağlıklı ve güvenli şekilde
        sürdürebilmek için kısa süreli bir düzenleme yapılmaktadır.
      </p>
    </div>

    <v-card-text class="payment-announcement-card__body">
      <div class="payment-announcement-card__notice">
        <v-icon color="#1BC5BD" class="mr-3">mdi-shield-check-outline</v-icon>
        <div>
          <strong>
            Kartla ödeme ve kart kaydetme işlemlerine geçici olarak ara
            verilmiştir.
          </strong>
          <span>
            Bu işlemlerin kısa süre içinde yeniden sunulabilmesi için
            çalışmalarımız devam etmektedir.
          </span>
        </div>
      </div>

      <p>
        Bu süreçte mevcut ödeme kayıtlarınız Robosay üzerinde takip edilmeye
        devam eder. Ödemelerinizi geçici süreyle site veya apartman
        yönetiminizin paylaştığı IBAN üzerinden havale/EFT yoluyla
        gerçekleştirebilir, detaylar için yönetiminizle iletişime
        geçebilirsiniz.
      </p>
      <p class="mb-0">
        Kartlı ödeme işlemleri yeniden aktif olduğunda Robosay üzerinden ayrıca
        bilgilendirme yapılacaktır.
      </p>
    </v-card-text>

    <v-card-actions class="payment-announcement-card__actions">
      <v-spacer></v-spacer>
      <v-btn
        color="#1BC5BD"
        depressed
        class="payment-announcement-card__button"
        @click="$emit('dismiss')"
      >
        Bilgiyi Aldım
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss">
.payment-announcement-card {
  border-radius: 18px !important;
  overflow: hidden;
}

.payment-announcement-card__hero {
  background: linear-gradient(135deg, #f6fbfa 0%, #edf7f6 58%, #ffffff 100%);
  border-bottom: 1px solid rgba(27, 197, 189, 0.18);
  padding: 34px 38px 26px;
}

.payment-announcement-card__logo {
  display: block;
  height: 52px;
  margin-bottom: 24px;
  max-width: 190px;
  object-fit: contain;
  object-position: left center;
}

.payment-announcement-card__eyebrow {
  color: #1bc5bd;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.payment-announcement-card__hero h2 {
  color: #263238;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.25;
  margin: 0 0 12px;
}

.payment-announcement-card__hero p,
.payment-announcement-card__body p {
  color: #5f6b73;
  font-size: 15px;
  line-height: 1.65;
}

.payment-announcement-card__hero p {
  margin: 0;
}

.payment-announcement-card__body {
  padding: 28px 38px 12px !important;
}

.payment-announcement-card__notice {
  align-items: flex-start;
  background: rgba(27, 197, 189, 0.08);
  border: 1px solid rgba(27, 197, 189, 0.24);
  border-radius: 10px;
  display: flex;
  margin-bottom: 22px;
  padding: 16px 18px;
}

.payment-announcement-card__notice strong {
  color: #263238;
  display: block;
  font-size: 15px;
  line-height: 1.45;
  margin-bottom: 6px;
}

.payment-announcement-card__notice span {
  color: #65737b;
  display: block;
  font-size: 14px;
  line-height: 1.55;
}

.payment-announcement-card__actions {
  padding: 12px 38px 34px !important;
}

.payment-announcement-card__button {
  border-radius: 8px;
  color: #fff !important;
  font-weight: 700;
  letter-spacing: 0;
  min-width: 144px;
  text-transform: none;
}

@media screen and (max-width: 600px) {
  .payment-announcement-card__hero,
  .payment-announcement-card__body,
  .payment-announcement-card__actions {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  .payment-announcement-card__hero h2 {
    font-size: 22px;
  }

  .payment-announcement-card__logo {
    height: 44px;
    max-width: 160px;
  }
}
</style>

<script>
export default {
  name: "PaymentAnnouncement06052026",
};
</script>
